var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup286(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 30.718,
    height: 42.8,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(-468 -3893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(468 3893)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(485 3904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M7.489,23.229a4.388,4.388,0,0,0-6.206,6.206L8.347,36.5l2.413,5.548a1.254,1.254,0,0,0,1.15.754H26.961a1.254,1.254,0,0,0,1.19-.858,51.351,51.351,0,0,0,2.567-16.015v-4.61a3.762,3.762,0,0,0-5.148-3.5,3.762,3.762,0,0,0-5.015-2.508,3.77,3.77,0,0,0-1.2-1.881A8.778,8.778,0,1,0,8.148,16.708v7.179Zm14.451-5.674a1.255,1.255,0,0,1,1.254,1.254v2.508a1.254,1.254,0,1,0,2.508,0,1.254,1.254,0,0,1,2.508,0v4.61a48.968,48.968,0,0,1-2.163,14.365H12.732l-2.18-5.012a1.252,1.252,0,0,0-.263-.387L3.056,27.661A1.88,1.88,0,0,1,5.716,25l2.8,2.8a1.254,1.254,0,0,0,2.14-.887V8.777a1.254,1.254,0,1,1,2.508,0V21.316a1.254,1.254,0,1,0,2.508,0V16.3a1.254,1.254,0,1,1,2.508,0v5.016a1.254,1.254,0,1,0,2.508,0V18.808a1.255,1.255,0,0,1,1.254-1.254M5.64,8.777a6.269,6.269,0,1,1,11.285,3.762,3.746,3.746,0,0,0-1.254.215V8.777a3.762,3.762,0,0,0-7.523,0v5.016A6.283,6.283,0,0,1,5.64,8.777",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup286);
export default __webpack_public_path__ + "static/media/Group 286.265eb964597e00df3f7367defea82ca5.svg";
export { ForwardRef as ReactComponent };